import React from 'react';

import MuiListItem, {
  ListItemProps as MuiListItemProps,
} from '@mui/material/ListItem';
import clsx from 'clsx';

import { CoreProps } from '../../types';
import { withCoreProps } from '../../withCoreProps';

export const ListItem = withCoreProps<ListItemProps>(
  ({
    children,
    className,
    ...props
  }: React.PropsWithChildren<ListItemProps>) => {
    // const classes = useStyles({});
    const clsxClass = clsx(className);

    return (
      <MuiListItem {...props} className={clsxClass}>
        {children}
      </MuiListItem>
    );
  },
);

export interface ListItemProps
  extends Omit<MuiListItemProps, 'button'>,
    CoreProps {}
